<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <h1>% de área bajo sequía</h1>
              <button @click="$emit('close')">&#x2716;</button>
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <p>
Esta opción calcula para cada año entre 1400-2019, el área de la región (% del total de pixeles), que se encuentra bajo cierta condición de sequía (valores iguales o menores al umbral PDSI indicado), generando una serie de tiempo
              </p>

              <hr />
              PDSI umbral: <input type="number" v-model="dai_in_formulario" name="Valor umbral de PDSI: " />
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button
                type="button"
                class="btn btn-success"
                style="width: 100%"
                @click="send_dai_value_to_process"
              >
                Calcular
              </button>
                            <button
                type="button"
                class="btn btn-success"
                style="width: 100%"
                @click="clean_dai"
              >
                Limpiar 
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalDAI",
  components: {},
  props: ["dai_val", "waiting", "waiting_msg"],
  data() {
    return {
      dai_in_formulario: -1,
    };
  },
  mounted() {
  },
  methods: {

clean_dai(){
    this.$emit("update:dai_val", null);
    this.$emit("recalc_dai");
    this.$emit("close")

},
    send_dai_value_to_process(){
    this.$emit("update:dai_val", this.dai_in_formulario);
    this.$emit("recalc_dai");
    this.$emit("close")
    }

  },
};
</script>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
